<template>
  <CRow>
    <CCol lg="12">
      <CCard>
          <CCardHeader>
          <strong>Quản lý bảo hành</strong>
          <div class="card-header-actions">
            <CButton v-if="allowCreate" type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
            <CButton type="button" shape="pill" color="secondary"
                     class="ml-1 mr-1"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="guarantees"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' '}"
            column-filter
            hover
            sorter
            clickable-rows
            pagination
            @row-clicked="editRecord"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      allowCreate: true,
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'customer', label: 'Khách hàng' },
        { key: 'project', label: 'Lô sản xuất' },
        { key: 'recv_bill', label: 'Biên bản nhận', _classes: 'font-weight-bold' },
        { key: 'recv_date', label: 'Ngày nhận' , _style:'width:8rem;'},
        // { key: 'send_bill', label: 'Biên bản giao'},
        // { key: 'send_date', label: 'Ngày trả (dự kiến)' },
        { key: 'quantity', label: 'Số lượng'},
        { key: 'error', label: 'Lỗi' },
        { key: 'status', label: 'Tình trạng' },
        { key: 'updated', label: 'Cập nhật' },
      ],
      // Example data
      guarantees: [],
      withProject: '',
    };
  },
  created() {
    this.withProject = this.$route.query.project;
    this.getAll(this.withProject)
  },
  methods: {
    getAll(project) {
      if (project) {
        this.$request(`/api/device/guarantee/project/${project}`).then(res => {
          // console.log(res.data)
          this.guarantees = res.data.guarantees
        })
      } else {
        this.$request('/api/device/guarantee').then(res => {
          // console.log(res.data)
          this.guarantees = res.data.guarantees
        })
      }
    },
    editRecord(item, index) {
      // console.log('Edit record:', item);
      this.$router.push({
        path: `/device/guaedit`,
        query: {
          id: item.id,
        },
      })
    },
    createNew() {
      this.$router.push({
        path: '/device/guaedit',
      })
    },
    goBack() {
      this.$router.go(-1)
    },
  },
};
</script>
